module.exports = __webpack_public_path__ + "static/img/2.ca13133.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/2.png
// module id = BFQh
// module chunks = 0